export default __webpack_public_path__ + "static/media/SaintMichelBackground.0c5acf77.png";